/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'


import { Alert, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAuth } from '../auth';
import { ADD_PRODUCT_BY_USERID } from '../../../urls';



export function AddProduct() {

    const { currentUser, logout } = useAuth()
    // Formu yalnizca girisli kullaniciya gosteren kapi icin (asagida).
    const id = currentUser?.id
    const token = currentUser?.token

    const [loading, setLoading] = useState(false)



    const [alertVariant, setAlertVariant] = useState("danger")
    const [showAlert, setShowAlert] = useState(false)
    // Baslangic metni BOSALDI: eskiden "Aynı node id'li cihaz eklenemez" yaziyordu
    // ve bu sayfanin node id ile hicbir ilgisi yok -- sablondan kalma.
    const [alertText, setAlertText] = useState("")
    const [stockCode, setStockCode] = useState("")


    const createHeader = () => {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', "" + token?.toString());
        return headers
    }



    const getReparationType = () => {
        return (
            <>
                {/* süre */}
                <option value={0}>Seçenekler</option>
                <option value={1}>Rulman</option>
                <option value={3}>Kasnak</option>
                <option value={9}>Motor</option>
                {/* trigger */}
                <option value={2}>Role</option>
                <option value={4}>Kontaktör</option>
                <option value={6}>Button</option>

                {/* ağrılık */}
                <option value={5}>Halat</option> 
                <option value={7}>Kanca</option> 

                {/* <option value={10}>Diğer</option> */}

            </>
        )
    }






    const [isCustomized, setIsCustomized] = useState(false)
    const changeProductType = (e) => {
        if (e === 10) setDeviceTimeType("1")
        else if (e === 5 || e === 7) setDeviceTimeType("4")
        else if (isEven(e)) setDeviceTimeType("2")
        else setDeviceTimeType("3")
    }
    const [deviceType, setDeviceType] = useState("0")
    const [deviceTimeType, setDeviceTimeType] = useState("1") //1 -> custumized 2-> trigger 3-> time 4-> weight
    const [description, setDescription] = useState("")
    const [brand, setBrand] = useState("")
    const [model, setModel] = useState("")
    const [maxUsageTime, setMaxUsageTime] = useState(0)
    const [isActive, setIsActive] = useState("0")
    const [choosenTime, setChoosenTime] = useState("0")
    const changeDataType = input => {

        if (input.target.value === "10") {
            setIsCustomized(true)
            setDeviceType(input.target.value);
            changeProductType(parseInt(input.target.value))
        }
        else {
            setIsCustomized(false)
            setDeviceType(input.target.value);
            changeProductType(parseInt(input.target.value))
        }

    }

    function isEven(number) {
        return number % 2 === 0;
    }


    function isNumeric(str) {
        return /^[0-9]+$/.test(str);
    }

    /**
     * Uyariyi gosterir.
     *
     * RENGI HER SEFERINDE yeniden kuruyor. Onceden yalnizca basari dali
     * `setAlertVariant("primary")` yaziyor, hata dallari rengi HIC geri
     * cevirmiyordu: bir kez basarili kayit yapildiktan sonra gelen HATA
     * mesajlari da mavi (basari rengi) goruniyordu.
     */
    const uyariGoster = (tip: string, metin: string) => {
        setAlertVariant(tip)
        setAlertText(metin)
        setShowAlert(true)
        setTimeout(() => setShowAlert(false), 4000)
    }


    function sendData() {
        
        const data = {
            "deviceType": deviceType,
            "description": description,
            "brand": brand,
            "model": model,
            "maxUsageTime": maxUsageTime,
            "isActive": isActive === "0" ? false : true,
            "choosenTime": choosenTime,
            "deviceTimeType": deviceTimeType,
            "userId": currentUser?.id,
            "stockCode" : stockCode

        }
        console.log(data)
        if (!isNumeric(maxUsageTime)) {
            uyariGoster("danger", "Girilen sürenin sayı olması gerekiyor.")
        }
        else if (deviceType === "10" && choosenTime === "0") {
            uyariGoster("danger", "Cihaz süre türünü seçmeniz gerekiyor.")
        }
        else if (deviceType !== "0") {
            AddProduct(data)
        } else {
            uyariGoster("danger", "Girilen bilgiler eksik veya yanlış.")
        }

    }
    /**
     * Urunu kaydeder.
     *
     * Onceden yalnizca 401, 400 ve 200 ele aliniyordu: 500, 403 ya da 404
     * donduginde ekranda HICBIR SEY olmuyordu. Ustelik `response.json()`
     * KOSULSUZ cagriliyordu, yani 500'de HTML govdeyi cozmeye calisip
     * SyntaxError atiyor ve o istisna yakalanmiyordu (`catch` yoktu). Yanit
     * govdesi de yalnizca `console.log`'a gidiyordu, yani cozmenin bir faydasi
     * da yoktu -- cagri tamamen kaldirildi.
     *
     * Dugmedeki gostergeyi suren `loading` state'i HIC YAZILMIYORDU; artik
     * istek suresince aciliyor.
     */
    async function AddProduct(data: any) {
        setLoading(true)
        try {
            const response = await fetch(ADD_PRODUCT_BY_USERID + `?id=${currentUser?.id}`, {
                method: "POST",
                headers: createHeader(),
                body: JSON.stringify(data)
            })
            if (response.status === 401) { logout(); return }
            if (!response.ok) { throw new Error(`HTTP ${response.status}`) }

            uyariGoster("primary", "Ürün başarılı bir şekilde kaydedildi.")
        } catch (e) {
            console.error("Urun kaydedilemedi:", e)
            uyariGoster("danger", "Kaydedilemedi.")
        } finally {
            setLoading(false)
        }
    }
    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip-2" {...props}>
            "Diğer" dışındaki tüm cihazları sistem otomatik yapılandırır.
        </Tooltip>
    );
    return (


        <>

            <div className='card mb-5 mb-xl-10'>
                <div
                    className='card-header border-0 cursor-pointer'
                    role='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#kt_account_profile_details'
                    aria-expanded='true'
                    aria-controls='kt_account_profile_details'
                >
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>Ürün Ekleme</h3>
                    </div>
                </div>
                {id !== undefined &&
                    <div id='kt_account_profile_details' className='collapse show'>
                        <form noValidate className='form'>
                            <div className='card-body border-top p-9'>


                                <div className='row mb-6'>
                                    <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={renderTooltip}
                                    >
                                        <label className='col-lg-2 col-form-label fw-bold fs-6'>
                                            <span className='required'>Eklenecek Tür</span>
                                        </label>
                                    </OverlayTrigger>
                                    <div className='col-lg-4 fv-row'>
                                        <select
                                            className='form-select form-select-solid form-select-lg fw-bold'

                                            onClick={(e) => changeDataType(e)}
                                        >
                                            {getReparationType()}
                                        </select>
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'></div>
                                        </div>
                                    </div>

                                </div>
                                <div className='row mb-6'>
                                    <div style={{ maxWidth: "200px", width: "100%", display: "inline-block", marginTop: "7px" }}>
                                        <Form.Label aria-label="Default select example" id="graphicType">
                                            Açıklama
                                        </Form.Label>
                                    </div>
                                    <div style={{ maxWidth: "500px", width: "100%", display: "inline-block", }}>
                                        <Form.Control aria-label="Default select example" id="graphicType" onChange={e => setDescription(e.target.value)}>

                                        </Form.Control>
                                    </div>
                                </div>

                                <div className='row mb-6'>
                                    <div style={{ maxWidth: "200px", width: "100%", display: "inline-block", marginTop: "7px" }}>
                                        <Form.Label aria-label="Default select example" id="graphicType">
                                            Marka
                                        </Form.Label>
                                    </div>
                                    <div style={{ maxWidth: "500px", width: "100%", display: "inline-block", }}>
                                        <Form.Control aria-label="Default select example" id="graphicType" onChange={e => setBrand(e.target.value)}>

                                        </Form.Control>
                                    </div>
                                </div>

                                <div className='row mb-6'>
                                    <div style={{ maxWidth: "200px", width: "100%", display: "inline-block", marginTop: "7px" }}>
                                        <Form.Label aria-label="Default select example" id="graphicType">
                                            Model
                                        </Form.Label>
                                    </div>
                                    <div style={{ maxWidth: "500px", width: "100%", display: "inline-block", }}>
                                        <Form.Control aria-label="Default select example" id="graphicType" onChange={e => setModel(e.target.value)}>

                                        </Form.Control>
                                    </div>
                                </div>
                                <div className='row mb-6'>
                                    <div style={{ maxWidth: "200px", width: "100%", display: "inline-block", marginTop: "7px" }}>
                                        <Form.Label aria-label="Default select example" id="graphicType">
                                            Stok Kodu
                                        </Form.Label>
                                    </div>
                                    <div style={{ maxWidth: "500px", width: "100%", display: "inline-block", }}>
                                        <Form.Control aria-label="Default select example" id="graphicType" onChange={e => setStockCode(e.target.value)}>

                                        </Form.Control>
                                    </div>
                                </div>
                                <div className='row mb-6'>
                                    <div style={{ maxWidth: "200px", width: "100%", display: "inline-block", marginTop: "7px" }}>
                                        <Form.Label aria-label="Default select example" id="graphicType">
                                            {deviceTimeType === "1" ?
                                                "özelleştirildi" :
                                                deviceTimeType === "2" ?
                                                    "Maximum çekme sayısı (Tetik)" :
                                                    deviceTimeType === "4" ?
                                                        "Toplam Taşıyabileceği max ağırlık" :
                                                        "Maximum çalışma süresi (Saat)"}
                                        </Form.Label>
                                    </div>
                                    <div style={{ maxWidth: "500px", width: "100%", display: "inline-block", }}>
                                        <Form.Control aria-label="Default select example" id="graphicType" onChange={e => setMaxUsageTime(parseInt(e.target.value))}>

                                        </Form.Control>
                                    </div>
                                </div>

                                <div className='row mb-6'>
                                    <div style={{ maxWidth: "200px", width: "100%", display: "inline-block", marginTop: "7px" }}>
                                        <Form.Label aria-label="Default select example" id="graphicType">
                                            Durum
                                        </Form.Label>
                                    </div>

                                    <div className='col-lg-4 fv-row'>
                                        <select
                                            className='form-select form-select-solid form-select-lg fw-bold'
                                            onChange={e => setIsActive(e.target.value)}
                                        >
                                            <option value='0'>Pasif</option>
                                            <option value='1'>Aktif</option>

                                        </select>

                                    </div>
                                </div>
                                {isCustomized &&
                                    <>
                                        <div className='row mb-6'>
                                            <div style={{ maxWidth: "200px", width: "100%", display: "inline-block", marginTop: "7px" }}>
                                                <Form.Label aria-label="Default select example" id="graphicType">
                                                    Süre Seçimi
                                                </Form.Label>
                                            </div>
                                            <div className='col-lg-4 fv-row'>
                                                <select
                                                    className='form-select form-select-solid form-select-lg fw-bold'
                                                    onChange={e => setChoosenTime(e.target.value)}
                                                >
                                                    <option value='0'>Seçenekler</option>
                                                    <option value='1'>Zaman (saat)</option>
                                                    <option value='2'>Trigger sayısı (çekme sayısı)</option>
                                                    <option value='3'>Taşıyabileceği max ağırlık</option>
                                                </select>

                                            </div>
                                        </div>

                                    </>
                                }





                            </div>

                            <Alert key={alertVariant} variant={alertVariant} show={showAlert}>
                                {alertText}
                            </Alert>
                            <div className='card-footer d-flex justify-content-end py-6 px-9'>
                                <a className='btn btn-primary' onClick={sendData}>
                                    {!loading && 'Değişikleri Kaydet'}
                                    {loading && (
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            Please wait...{' '}
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </span>
                                    )}
                                </a>
                            </div>

                        </form>

                    </div >
                }

            </div >
        </>

    )
}
